import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { HOLIDAYS_URLS, USER_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { role_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  name: Yup.string()
    .required("Required")
    .min(2, "Name must be at least 2 characters"),
  date: Yup.date().required("Required"),
});
const HolidayForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema), 
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);

  useEffect(() => {
    role_get_select((data: any) => setAllRole(data));
  }, []);

  //   const onSubmit = (data: any) => {
  //     console.log("Form submitted:", data);
  //   };
  const onSubmit = (data: any) => {
    let url = HOLIDAYS_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = HOLIDAYS_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const options = [
    { value: "1", label: "Test" },
    { value: "2", label: "Test" },
    { value: "3", label: "test" },
  ];
  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "name",
      element: {
        label: "Enter Holiday Name",
        isRequired: true,
        // inputProps: { isFocussed: true },
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "date",
      element: {
        label: "Enter Date",
        isRequired: true,
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default HolidayForm;
